import React from "react";
import { Box, Button, Collapse, Stack, Typography, useMediaQuery } from "@mui/material";
import { FieldBlock, FieldLabel, HistoryDetail, ToggleArrow, detailIdFor } from "./HistoryRow";
import { CARD_LAYOUT, fieldLabel } from "./historyFormat";
import { TOUCH, focusRing } from "./regmStyles";

// Narrow-screen History record: a plain list item (dividers between items, no card chrome).
// Renders CARD_LAYOUT through the same FieldBlock as the table, with the same handlers and detail.
const HistoryCard = ({
  record,
  open,
  onToggle,
  verify,
  onVerify,
  reviews,
  onRetryReviews,
  pdf,
  onPdf,
  action,
  onReview,
}) => {
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)", { noSsr: true });
  const detailId = detailIdFor(record);
  const blockProps = { record, pdf, onPdf, action, onReview };
  return (
    <Box component="li" sx={{ py: 2, borderBottom: 1, borderColor: "divider", minWidth: 0 }}>
      <Stack spacing={0.5} sx={{ minWidth: 0 }}>
        {CARD_LAYOUT.header.map((key) => (
          <Box key={key} sx={{ minWidth: 0 }}>
            <FieldBlock field={key} {...blockProps} />
          </Box>
        ))}
      </Stack>
      <Box
        component="dl"
        sx={{
          display: "grid",
          gridTemplateColumns: "minmax(64px, max-content) minmax(0, 1fr)",
          columnGap: 2,
          rowGap: 1,
          alignItems: "start",
          my: 1.5,
        }}
      >
        {CARD_LAYOUT.rows.map((key) => (
          <React.Fragment key={key}>
            <Typography component="dt" variant="body2" color="text.secondary" sx={{ lineHeight: "24px" }}>
              <FieldLabel field={key} label={fieldLabel(key)} />
            </Typography>
            <Box component="dd" sx={{ m: 0, minWidth: 0 }}>
              <FieldBlock field={key} {...blockProps} />
            </Box>
          </React.Fragment>
        ))}
      </Box>
      <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="space-between" useFlexGap flexWrap="wrap">
        {CARD_LAYOUT.footer.map((key) => (
          <FieldBlock key={key} field={key} {...blockProps} />
        ))}
        <Button
          variant="text"
          color="inherit"
          onClick={() => onToggle(record.id)}
          aria-expanded={open}
          aria-controls={detailId}
          aria-label={`${open ? "Hide" : "Show"} details for ${record.security}`}
          startIcon={<ToggleArrow open={open} reducedMotion={reducedMotion} />}
          sx={{ minHeight: TOUCH, ...focusRing }}
        >
          {open ? "Hide details" : "Show details"}
        </Button>
      </Stack>
      <Box id={detailId}>
        <Collapse in={open} timeout={reducedMotion ? 0 : "auto"} unmountOnExit>
          <Box sx={{ mt: 1, px: 1.5, bgcolor: "action.hover", borderRadius: 1 }}>
            <HistoryDetail
              record={record}
              reviews={reviews}
              verify={verify}
              onVerify={onVerify}
              onRetryReviews={onRetryReviews}
            />
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default HistoryCard;
